import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ISchema } from "../../validation-types/SchemaDefinition";

const buildPutObjectKey = ({
  whiteLabelID,
  isLogo,
  isDarkModeLogo,
}: {
  readonly whiteLabelID: string;
  readonly isLogo: boolean;
  readonly isDarkModeLogo?: boolean;
}): string => {
  if (!isLogo) {
    return `${whiteLabelID}-favicon`;
  }
  if (isDarkModeLogo) {
    return `${whiteLabelID}-logo-dark`;
  }
  return `${whiteLabelID}-logo`;
};

export const generateLogoPutUrl = (axios: IAxiosInstance) => {
  return async ({
    whiteLabelID,
    contentType,
    usePrimary = true,
    isLogo,
    isDarkModeLogo = false,
  }: ISchema["#/definitions/IGenerateLogoPutUrlArgs"]) => {
    const response = await axios.noRetry.get<{
      data: ISchema["#/definitions/IGenerateLogoPutUrlResponse"];
    }>(`/generate-logo-put-url`, {
      params: {
        key: buildPutObjectKey({ whiteLabelID, isLogo, isDarkModeLogo }),
        contentType: contentType,
        usePrimary,
        whiteLabelID,
      },
      headers: {
        "Content-Type": contentType,
      },
    });

    const resData = response.data?.data;

    if (resData) {
      return resData;
    }

    throw new Error("Something went wrong");
  };
};
